import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from 'i18next-browser-languagedetector';
import * as Config from "../config";

const en = require('../i18n/en.json');
const de = require('../i18n/de.json');
const it = require('../i18n/it.json');
const es = require('../i18n/es.json');
const ar = require('../i18n/ar.json');

i18n.use(initReactI18next)
    .use(LngDetector)
    .init({
        resources: {
            en: { translation: en },
            de: { translation: de },
            it: { translation: it },
            es: { translation: es },
            ar: { translation: ar }
        },
        lng: localStorage.getItem('i18nextLng') ?? Config.DEFAULT_LANGUAGE,
        keySeparator: '.',
        fallbackLng: 'en',
        whitelist: ['de', 'en', 'it', 'es', 'ar'],
        interpolation: {
            escapeValue: false
        }
    });
export default i18n;